var r="@hpstellar/core/reward-badge";export{r as rewardBadgeTestId};
